import type {ComponentType, ReactNode} from 'react'

import {RouteProfiler} from '../ProfilerContext'

export function wrapWithProfiler(
  profilerId: string,
  {element, Component}: {element: ReactNode; Component: ComponentType | null | undefined},
): React.ReactElement | undefined {
  if (!element && !Component) return undefined

  let node: null | React.ReactElement = null
  if (element !== undefined) {
    node = <>{element}</>
  } else if (Component) {
    node = <Component />
  }

  if (!node) return undefined

  return <RouteProfiler id={profilerId}>{node}</RouteProfiler>
}
